import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import ajax from '@/utils/ajax';

export type DemographicOptionKey =
  | 'race_ethnicity'
  | 'housing_status'
  | 'employment_status'
  | 'gender'
  | 'sex'
  | 'pronouns'
  | 'transgender'
  | 'sexual_orientation'
  | 'education'
  | 'relationship_status'
  | 'experience_in_treatment'
  | 'opiod_use_oxy'
  | 'opiod_use_heroin_fentanyl';

export type DemographicsOptionsResponse = {
  [K in DemographicOptionKey]: string[];
};

const basePath = '/api/demographics/options';

export const demographicsRepository = {
  async getDemographicOptions({ host }: { host: string }): Promise<DemographicsOptionsResponse> {
    const response = await ajax.get({
      url: `${host}${basePath}`
    });

    return response.data;
  },

  async getSpecificDemographicOptions({
    host,
    optionKey
  }: {
    host: string;
    optionKey: DemographicOptionKey;
  }): Promise<string[]> {
    const options = await this.getDemographicOptions({ host });
    return options[optionKey];
  }
};

const DemographicsRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getDemographicOptions(): Promise<DemographicsOptionsResponse> {
      return demographicsRepository.getDemographicOptions({ host });
    },

    async getSpecificDemographicOptions(optionKey: DemographicOptionKey): Promise<string[]> {
      return demographicsRepository.getSpecificDemographicOptions({ host, optionKey });
    }
  };
};

export default DemographicsRepository;
